/***
 * Widget utilities
 */
export const PeriodType = [
  { value: 'DAY', label: 'Today' },
  { value: 'WEEK', label: 'This Week' },
  { value: 'MONTH', label: 'This Month' },
  { value: 'YEAR', label: 'This Year' }
];

export const WIDGET_FORMAT_OPTIONS = [
  { value: 'GENERAL', label: 'General' },
  { value: 'MMSS', label: 'Time (MM:SS)' }
];

export const WIDGET_COMPARISION_OPERATORS = [
  { value: '=', label: 'Equal' },
  { value: '<', label: 'Less Than' },
  { value: '<=', label: 'Less Than Equal To' },
  { value: '>', label: 'Greater Than' },
  { value: '>=', label: 'Greater Than Equal To' },
  { value: '!=', label: 'Not Equal' }
];

export const WIDGET_COLOURS = [
  { value: 'primary', label: 'Blue (primary)', textCol: 'text-dark' },
  { value: 'secondary', label: 'Grey (Secondary)', textCol: 'text-dark' },
  { value: 'success', label: 'Green (Success)', textCol: 'text-dark' },
  { value: 'info', label: 'Light Blue (Info)', textCol: 'text-dark' },
  { value: 'warning', label: 'Orange (Warning)', textCol: 'text-dark' },
  { value: 'danger', label: 'Red (Danger)', textCol: 'text-dark' },
  { value: 'light', label: 'White (Light)', textCol: 'text-dark' },
  { value: 'dark', label: 'Black (Dark)', textCol: 'text-dark' }
];

export const getFirstColumnValue = data => {
  return data[0][Object.keys(data[0])[0]];
};

export const widgetItemColors = ['primary', 'info', 'warning', 'danger'];

/* Returns first index of the operators list that is true for the value provided */
export function TestConditionalOperator(value, target, operator) {
  let valid = false;

  if (operator == '=') {
    valid = value == target;
  } else if (operator == '<') {
    valid = value < target;
  } else if (operator == '<=') {
    valid = value <= target;
  } else if (operator == '>') {
    valid = value > target;
  } else if (operator == '>=') {
    valid = value >= target;
  } else if (operator == '!=') {
    valid = value != target;
  }

  return valid;
}

export function WidgetFormatValue(value, format) {
  if (format == 'MMSS') {
    const minutes = Math.floor(value / 60); // Calculate minutes
    const remainingSeconds = value % 60; // Calculate remaining seconds

    // Ensure two-digit formatting using String.padStart()
    const formattedMinutes = String(minutes).padStart(2, '0');
    const formattedSeconds = String(remainingSeconds).padStart(2, '0');

    return `${formattedMinutes}:${formattedSeconds}`;
  }
  return value;
}

export function WidgetSaveKV(widget, key, value) {
  let k = `widget.${widget.id}.${key}`
  localStorage.setItem(k, value);
}

export function WidgetLoadKV(widget, key, defaultValue) {
  let k = `widget.${widget.id}.${key}`
  let val = localStorage.getItem(k);
  if (val === null) {
    WidgetSaveKV(widget, key, defaultValue);
    return defaultValue;
  }
  return val;
}

export function WidgetLoadKVBool(widget, key, defaultValue) {
  let val = WidgetLoadKV(widget, key, defaultValue);
  return val === 'true'
}